
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    import mensaje from './sala-mensajes-mensaje.vue';
    import previsuacion from './barra-respuestas/previsuacion-archivos.vue';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            mensaje,
            previsuacion
        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        public get Mensajes() { return this.Controlador.Mensajes; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public NuevoMensaje: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );


        }

        mounted()
        {
            this.Eventos.push( this.Controlador.onNuevoMensaje.subscribe( ( x ) =>
            {
                this.NuevoMensaje = true;
            } ) );

            this.Eventos.push( this.Controlador.onScrollYFocus.subscribe( () =>
            {
                this.$nextTick( () =>
                {
                    this.ScrollMensajes();
                } );

            } ) );


            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () =>
            {
                if ( this.Controlador.Vista.Estado == 'ok' )
                    this.$nextTick( () =>
                    {
                        this.ScrollMensajes();
                    } );

            } ) );

            document.getElementById( "mensajes-sala" ).addEventListener( 'scroll', this.onScroll );
        }

        public ScrollTop: number = 0;
        public ScrollBottom: number = 0;
        public scrollHeight: number = 0;
        public MuestraDeslizar: boolean = false;
        public MuestraMasMensajes: boolean = false;
        public CargandoMas: boolean = false;
        public onScroll( e: Event )
        {
            this.ScrollTop = e.srcElement.scrollTop;
            this.scrollHeight = e.srcElement.scrollHeight;

            if ( this.ScrollTop < 30 )
            {
                if ( this.Mensajes.hasRows() && this.Mensajes[0].Id != this.Controlador.Chat.PrimerMensaje )
                    this.MuestraMasMensajes = true;
            } else
            {
                this.MuestraMasMensajes = false;
            }
            this.ScrollBottom = e.srcElement.scrollHeight - ( e.srcElement.scrollTop + e.srcElement.offsetHeight );

            //console.log( e.srcElement.scrollHeight );
            //console.log( this.ScrollBottom );

            this.MuestraDeslizar = this.ScrollBottom > 100;
            if ( !this.MuestraDeslizar )
            {
                this.NuevoMensaje = false;
            }

        }

        ScrollMensajes()
        {
            this.NuevoMensaje = false;
            Utiles.ElementScrollBottom( document.getElementById( 'mensajes-sala' ) );
        }

        async CargarMasMensajes()
        {
            this.CargandoMas = true;
            let ofs = this.scrollHeight;
            await this.Controlador.CargarMasMensajes();
            this.CargandoMas = false;

            await Wait( 100 );
            this.$nextTick( () =>
            {
                let e = document.getElementById( 'mensajes-sala' ).scrollHeight - ofs - 80;
                Utiles.ElementScroll( document.getElementById( 'mensajes-sala' ), { top: e } );
            } );

        }

    }
